<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 24 24">
    <path
      d="M20.7777 12.6113H5.12717L12.6527 20.1317L11.7839 20.9999L2.77775 11.9999L11.7839 2.99992L12.6527 3.86812L5.12717 11.3885H20.7777V12.6113Z"
      :class="colorClass"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.7839 2.64648L13.0063 3.86812L5.73101 11.1385H21.0277V12.8613H5.73101L13.0063 20.1317L11.7839 21.3534L2.42407 11.9999L11.7839 2.64648ZM3.13142 11.9999L11.7839 20.6465L12.299 20.1317L4.52332 12.3613H20.5277V11.6385H4.52332L12.299 3.86812L11.7839 3.35335L3.13142 11.9999Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
